// Cloudflare Worker URL
export const WORKER_URL = 'https://esayt-upload-worker.najaflisaid1.workers.dev';
